import api from '@api'
import SortBy from 'lodash/sortBy'
import { transformAssetTypeRecursive } from '@data/asset-type'
import { isLoggedIn } from '@utils/auth'

export function getCITypeApi(archived = false) {
  return api
    .get(`${!isLoggedIn() ? '/public' : ''}/cmdb/citype`, {
      params: {
        ...(archived ? { archived: true } : {}),
      },
      loader: false,
      notify: false,
    })
    .then((data) => {
      return transformAssetTypeRecursive(SortBy(data, (d) => d.node.objOrder))
    })
}
